app.directive('customFields', [function () {
    return {
        templateUrl: 'templates/directives/customFields.html'
    }
}]);
